import * as meApi from '../api/meApi';
import * as types from '../constants/authConstants';

export const toUserData = (me) => ({
  id: me.id,
  firstName: me.firstName,
  lastName: me.lastName,
  picture: me.image,
  roles: (me.roles || []).map((r) => r.name),
});

export const persistProfile = (accessToken, user) => {
  const profile = { accessToken, user };
  localStorage.setItem('profile', JSON.stringify(profile));
  return profile;
};

export const hydrateAndDispatch = async (dispatch, accessToken) => {
  // Persist access token first so AUTH_API interceptor picks it up for the /me call.
  localStorage.setItem('profile', JSON.stringify({ accessToken, user: null }));
  const { error, data } = await meApi.getMe();
  if (error) {
    localStorage.removeItem('profile');
    throw new Error(error);
  }
  const profile = persistProfile(accessToken, toUserData(data));
  dispatch({ type: types.AUTHORIZATION_SUCCESS, payload: profile });
  return profile;
};
